import { Component, inject } from '@angular/core';
import { EventHubService } from '../../services/event-hub.service';

// Capture window events centrally

@Component({
    selector: 'app-event-hub',
    template: '',
    host: {
        '(window:paste)': 'onWindowPaste($event)'
    },
    standalone: true,
})
export class EventHubComponent {

  private eventHubService = inject(EventHubService);

  onWindowPaste(event: ClipboardEvent): void {
    this.eventHubService.handlePaste(event);
  }
}
